export const registryEmailValidator = async (email: string) => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@hp.com$/
  const result = (email || '').match(emailRegex)
  const badValidateAnswer = 'Only @hp.com email addresses are allowed.'

  return Promise.resolve(result ? '' : badValidateAnswer)
}
